import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/icon-search-small.svg';
import { ReactComponent as ClearIcon } from '../../../../assets/icons/icon-close.svg';

export const Components = {
  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    ${AppCSS.radiuses.default};
    overflow: hidden;
    background-color: ${AppCSS.colors.white};
    border: 1px solid ${AppCSS.colors.greys.light};
  `,
  SearchBar: styled.input`
    width: 100%;
    padding: 12px 16px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
    background-color: transparent;
    -webkit-appearance: none;
    border: none;
    outline: none;
    &:focus-visible {
      -webkit-appearance: none;
    }
    &:focus {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &::placeholder {
      color: ${AppCSS.colors.greys.veryDark};
    }
  `,
  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-right: 16px;
  `,
  SearchIcon: styled(SearchIcon)`
    width: 16px;
    height: 16px;
  `,
  ClearIcon: styled(ClearIcon)`
    width: 16px;
    height: 16px;
    cursor: pointer;
  `,
};
